import React from 'react';
import { Button, Spinner } from 'reactstrap';

interface BaseButtonProps {
  text?: string | React.ReactNode;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  color?: string;
  className?: string;
  fullWidth?: boolean;
  onClick?: ()=> void;
  icon?:any;
  size?:string
  children?: React.ReactNode;
}

const BaseButton: React.FC<BaseButtonProps> = ({
  onClick,
  text,
  loading = false,
  type = 'button',
  disabled = false,
  color = 'primary',
  icon,
  className,
  size,
}) => {
  return (
    <Button
    size={size}
    onClick={onClick}
    icon={icon}
      type={type}
      disabled={disabled || loading}
      color={color}
      className={className}
      style={{ width: '100%', marginTop: '0.7rem' }}
    >
      {loading && <Spinner size="sm" style={{ marginRight: '0.5rem' }} />}
      {text}
    </Button>
  );
};

export default BaseButton;
